module.exports = __webpack_public_path__ + "assets/img/w5.7b5ea7ac.png";